import { CustomerProfile } from '@models/resources/customer-profile.model';

/**
 * Stammdaten des Demo-Kunden für FE-First-Prototyp (Sprint 1–3).
 * Ersetzt im Sprint 4 durch `GET /api/me/customer`.
 */
export const DEMO_CUSTOMER_PROFILE: CustomerProfile = {
  id: 1,
  first_name: 'Maximilian',
  last_name: 'Holzner',
  email: 'customer@goldapp.local',
  phone: '+43 660 1234567',
  address: {
    street: 'Wipplingerstraße 35',
    postcode: '1010',
    place: 'Wien',
    country: 'Österreich',
  },
  depot_number: 'GS-2024-00127',
  customer_since: '2024-03-12',
};
